import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full px-4 md:px-6 xl:px-[72px] pb-4 md:pb-6 xl:pb-10" }
const _hoisted_2 = { class: "sf-pro font-normal text-base leading-100p xl:text-xl mr-6" }


import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowMoreButton',
  props: {
    isApiLoading: { type: Boolean }
  },
  emits: ["loadMoreBlogs"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["btn-container", props.isApiLoading ? 'pointer-events-none opacity-50' : '']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('loadMoreBlogs')))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("blog.show_more_btn")), 1),
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M7 7L17 17M17 17H7M17 17V7",
          stroke: "currentColor",
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1))
    ], 2)
  ]))
}
}

})